import { FORM_TEMPLATE_LIST } from '@features/forms/constants';
import { FormTemplatesApiResponse } from '@features/forms/types/formTemplatesApi';

export const MOCK_FORM_TEMPLATES_API: FormTemplatesApiResponse = {
  data: FORM_TEMPLATE_LIST.map((template) => ({
    name: template.name,
    summary: template.summary,
    description: template.description,
    fields: template.defaultFields.map((field) => ({
      name: field.label,
      type: field.type,
      is_required: field.required,
      display_order: field.order,
      sync_to_member: field.syncToMember ?? false,
      options: field.options ?? []
    })),
    add_to_mode: template.addToMode,
    fee_amount: template.feeAmount ?? null,
    is_partial_payment_enabled: template.acceptInstallments ?? null,
    min_partial_payment_amount: template.minPartialPaymentAmount ?? null,
    discount_config: template.applyDiscount
      ? {
          is_enabled: true,
          type: template.discountType ?? 'percentage',
          value: template.discountValue
        }
      : { is_enabled: false },
    icon_url: template.iconUrl ?? null
  }))
};

export default MOCK_FORM_TEMPLATES_API;
